import './MarketRunConfigFiltersStep.scss';
import React, { ReactNode, useState } from 'react';
import classnames from 'classnames';
import {
    MarketRunConfigFilters,
    MarketRunConfigFiltersProps,
} from '@/components/ConfigurationEditors/ReportConfigurationEditor/ReportRunConfigFilters';
import { AccordionWizard, StepRef } from '@byzzer/ui-components';
import { ConfigOptionsType } from '@/types/RunConfigOptions';
import { REQUIRED_FIELDS_NOT_FILLED_TIP } from '@/constants/market.constants';

export type MarketRunConfigFiltersStepProps = {
    title?: ReactNode;
    exclude?: boolean;
    id?: ConfigOptionsType;
} & MarketRunConfigFiltersProps;

const baseClassName = 'market-run-config-filters-step';

export const MarketRunConfigFiltersStep = React.forwardRef<StepRef, MarketRunConfigFiltersStepProps>(
    ({ className, title, id, exclude, ...props }, ref) => {
        const [filtersValid, setFiltersValid] = useState<boolean>(false);
        const [disabledTip, setDisabledTip] = useState<string>(REQUIRED_FIELDS_NOT_FILLED_TIP);

        function handleValidationChange(e: ByzzerValidityChangeEvent) {
            setFiltersValid(e.isValid);
            if (e.errors?.includes('missing_remaining_markets')) {
            } else {
            }
        }

        function handleDisabledTip(message: string) {
            setDisabledTip(message);
        }

        return (
            <AccordionWizard.Step
                className={classnames(baseClassName, className)}
                ref={ref}
                title={title}
                id={id}
                exclude={exclude}
            >
                <AccordionWizard.Header
                    className={classnames({
                        'report-run-config-wizard-header--valid': filtersValid,
                    })}
                >
                    <h1 className={'report-run-config-wizard__step-title'}>{title}</h1>
                </AccordionWizard.Header>
                <AccordionWizard.Content>
                    <MarketRunConfigFilters {...props} onValidityChange={handleValidationChange} handleDisabledTip={handleDisabledTip} />
                </AccordionWizard.Content>
                <AccordionWizard.Actions
                    disableNext={!filtersValid}
                    nextDisabledTip={disabledTip}
                />
            </AccordionWizard.Step>
        );
    }
);
